import { base } from './';

const PATH = '/home';

const get = () => base.get(PATH);

const post = () => base.post(PATH);

const patch = (collectionIds: number[]) => base.patch(PATH, { collectionIds });

export { post, get, patch };
